export enum IntakeListDataGridColumn {
  SEQUENCE_NUMBER = 'sequenceNumber',
  CREATED_AT = 'createdAt',
  STATUS = 'status',
  SUMMARY = 'summary',
  CREATED_BY = 'createdBy',
  DEMAND_ID = 'demandId',
  DEMAND_RESPONSIBLE_USERS = 'demandResponsibleUsers',
  ACTIONS = 'actions',
}

export enum IntakeListDataGridColumnGroup {
  PURCHASE_REQUISITION = 'purchaseRequisition',
  DEMAND = 'demand',
}
